/**
 * Versions of every consent text we show next to an email opt-in. The version
 * is stored with each subscription and in the append-only consent log
 * (`emailConsentEvents`), so we can prove which wording a person agreed to.
 *
 * RULE: change the consent wording in a dictionary => bump its version here.
 * `email-consent.test.ts` pins the current texts per version, so editing a
 * text without bumping the version fails CI.
 */

/** Newsletter form (pre-footer panel on every page, newsletter page). */
export const NEWSLETTER_CONSENT_VERSION = 'newsletter-2026-11-01'

/** Founding-member waitlist form (pricing page, paywall, homepage). */
export const FOUNDING_CONSENT_VERSION = 'founding-2026-11-01'

/** Re-subscribe from the signed preference center. */
export const PREFERENCE_CENTER_CONSENT_VERSION = 'preferences-2026-11-01'

/** Newsletter toggle in the signed-in account settings. */
export const SETTINGS_CONSENT_VERSION = 'settings-2026-11-01'

/** Source tags allowed on stored consent records. */
export const CONSENT_SOURCE_PATTERN = /^[a-z0-9_]{1,48}$/u

/**
 * Consent source for a free tool's lead capture: `tool_<slug>` with hyphens as
 * underscores, so it passes {@link CONSENT_SOURCE_PATTERN} (else it would be
 * recorded as `unknown` and we could not tell which tool converts).
 */
export function toolLeadSource(toolSlug: string): string {
  return `tool_${toolSlug.replace(/[^a-z0-9]+/gu, '_')}`.slice(0, 48)
}

export function cleanConsentSource(source: string): string {
  return CONSENT_SOURCE_PATTERN.test(source) ? source : 'unknown'
}
